import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import "./SignupCommon.css";
import rectangleGraph from "../../assets/images/Rectangle-graph.png";

const SignupPage13: React.FC = () => {
  const storedWeight = localStorage.getItem("weight");
  const storedIdealWeight = localStorage.getItem("idealWeight");

  let currentWeight: number | undefined;
  let idealWeight: number | undefined;
  if (storedWeight) {
    const weightData = JSON.parse(storedWeight);
    currentWeight = weightData.value;
  } else {
    console.error("No weight data found in localStorage.");
    currentWeight = undefined;
  }
  if (storedIdealWeight) {
    const idealWeightData = JSON.parse(storedIdealWeight);
    idealWeight = idealWeightData.value;
  } else {
    idealWeight = undefined;
  }

  const navigate = useNavigate();

  useEffect(() => {
    const step8Completed = localStorage.getItem("step-8-completed");
    if (step8Completed) {
      navigate("/getting-started/step-9", { replace: true });
    } else {
      navigate("/getting-started/step-8", { replace: true });
    }
  }, []);

  const handleNext = () => {
    localStorage.setItem("step-9-completed", "true");
    const isVariant = localStorage.getItem("isVariant") === "true";
    if(isVariant){
      navigate("/getting-started/step-12");
    }else{
      navigate("/getting-started/step-10");
    }
  };

  return (
    <PageWrapper>
      <div>
        <div className="signup-page-container container">
          <div className="signup-content">
            <p
              className="curved-journey-content"
              style={{ textAlign: "center" }}
            >
              It feels like magic, but it’s{" "}
              <span className="content-color">metabolic science.</span>
            </p>
            <div className="graphContainer">
              <img src={rectangleGraph} alt="Graph" />
            </div>

            <div
              style={{ paddingTop: "20px", paddingBottom: "20px" }}
              className="clinical-trails-div"
            >
              <span className="clinical-content">
                In clinical trails, GLP-1 patients{" "}
                <span style={{ fontWeight: "700" }}>
                  lost 18% of their body weight.
                </span>
              </span>
              <br></br>
              <br></br>
              <span className="clinical-content">
                Non-branded medications offer the{" "}
                <span style={{ fontWeight: "700" }}>
                  same active ingredient
                </span>{" "}
                as Wegovy®, Ozempic®, Zepbound® and Mounjaro® — but at a
                fraction of the price (80% less) and are more consistently
                available.
              </span>
            </div>
            <button onClick={handleNext} className="next-btn sticky-btn">
                Continue →
              </button>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage13;
